import {toastError, toastSuccess} from "../../component/shared/toast/Toast";
import i18n from "../../config/i18n";
import {getSafeBackendErrorMessage} from "../../util/utils";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import WishCodeService from "../../api/wishCodeService";


export const getWishCodes =
    createAsyncThunk(`${SliceNames.WISH_CODE}/getWishCodes`,
        async (wishId: string, thunkAPI) => {
            try {
                const res = await WishCodeService.fetchCodes(wishId)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })

export const deleteWishCode =
    createAsyncThunk(`${SliceNames.WISH_CODE}/deleteWishCode`,
        async (codeId: string, thunkAPI) => {
            try {
                await WishCodeService.deleteCode(codeId)
                toastSuccess(i18n.t('changes_saved_success'))
                return codeId
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const uploadWishCodes =
    createAsyncThunk(`${SliceNames.WISH_CODE}/uploadWishCodes`,
        async (req: {
            wishId: string, codes: File
        }, thunkAPI) => {
            try {
                await WishCodeService.uploadWishCodes(req.wishId, req.codes)
                toastSuccess(i18n.t('changes_saved_success'))
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })